// src/pages/PackagesPage.tsx

import React from 'react';
import { PackageList } from '../components/packages/PackageList';

export const PackagesPage: React.FC = () => <PackageList />;
